import { Footer } from '../components';
import Loading from '../../components/common/Loading';
import BlogCard from '../components/Blogs/BlogCard';
import { useBlogs } from '../../components/context/BlogContext';
import NoContent from '../../components/common/NoContent';
import GlobalHeader from '../../components/GlobalHeader';

const Blogs = () => {

  const { blogs, isLoading, hasMore, setSize, size } = useBlogs();
  if (isLoading) return <Loading />;

  return (
    <div className="bg-black min-h-screen">
      <GlobalHeader />
      <p className='text-white text-center text-2xl md:text-3xl lg:text-5xl font-semibold pt-8 md:pt-12 pb-4 px-4'>Protect your artistic integrity while <br className="hidden md:block" /> embracing innovation.</p>
      <div className="bg-black text-white p-8 px-4 md:px-12">
        <h2 className="text-2xl font-bold mb-8 ">All Articles</h2>
        <div className='flex flex-center justify-center w-[100vw] '>
          {!blogs || blogs.length === 0 && <NoContent title='No Blog Found' description="" />}
        </div>  
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9 min-h-[40vh]">


          {blogs.map((article, index) => (
            <BlogCard index={index} blog={article} key={article.id} />
          ))}
        </div>
        {hasMore && <div className="flex justify-center mt-8">
          <button onClick={() => hasMore ? setSize(size + 1) : null} className="border border-gray-400 text-white px-6 py-2 rounded-full ">
            Load more
          </button>
        </div>}
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;